<loader-container
  [loader]="loader"
  [options]="{
    contentTemplate: preview
  }"
  (loaded)="template = $event"
></loader-container>

<ng-template #preview>
  <div *ngIf="template">
    <data-preview
      [item]="template"
      [options]="{
        properties: {
        'createdBy': { heading: 'Created by', order: 51 },
        'id': { heading: 'UID', order: 1 },
        'name': { heading: 'Name', order: 2 },
        'description': { heading: 'Description', order: 3 },
        'messages': { hidden: true }
        }
      }"
    ></data-preview>
    <actions-container *ngIf="!hideActions" [ngClass]="'pb-4'">
      <back-button></back-button>
      <manage-button
        [isExisting]="true"
        [routerLink]="['../../manage', tenantId!]">
      </manage-button>
    </actions-container>
  </div>
</ng-template>
